module.exports = __webpack_public_path__ + "img/hiw-01.07d56335.png";